import { ITabPanelConfig } from '../../../../@core/components/ui/tabs-panels/tabs-panels.component';
import { InsightsTabComponent } from './insights-tab/insights-tab.component';
import { ApproversTabComponent } from './approvers-tab/approvers-tab.component';
import { SignatoriesTabComponent } from './signatories-tab/signatories-tab.component';
import { LinkedFilesTabComponent } from './linked-files-tab/linked-files-tab.component';
import { MilestonesTabComponent } from './milestones-tab/milestones-tab.component';
import { CommentsTabWrapperComponent } from './comments-tab/comments-tab.component';
import { HistoryTabWrapperComponent } from './history-tab/history-tab.component';
import { GeoTechnicalSummaryComponent } from '../../../../features/geotechnical-analysis/pages/geo-technical-analysis-report/tabs/geo-technical-summary/geo-technical-summary.component';
import { GeoTechnicalDashboardComponent } from '../../../../features/geotechnical-analysis/pages/geo-technical-analysis-report/tabs/geo-technical-dashboard/geo-technical-dashboard.component';

export interface EditContractTabConfig extends ITabPanelConfig {
    tour?: {
        stepId: string;
    };
}

export function createTabsConfig(
    contract: any,
    currentRole: string,
    externalUser: boolean,
    CONTRACT_USER_ROLE: any,
): EditContractTabConfig[] {
    if (externalUser) {
        if (contract?.containsForm) {
            return [{
                value: '0',
                label: contract?.containsForm ? 'Questionnaire' : 'Insights',
                icon: 'pi pi-chart-line',
                visible: true,
                component: InsightsTabComponent,
                tour: {
                    stepId: 'prevOfApprover'
                }
            }]
        }
        else { return [] }
    }

    return [
        {
            value: '0',
            label: contract?.containsForm ? 'Questionnaire' : 'Insights',
            icon: 'pi pi-chart-line',
            visible: true,
            component: InsightsTabComponent,
            tour: {
                stepId: contract?.containsForm ? 'step13' : 'prevOfApprover'
            }
        },
        {
            value: '1',
            label: 'Approvers',
            icon: 'pi pi-check-square',
            visible: true,
            component: ApproversTabComponent,
            tour: {
                stepId: 'step14'
            }
        },
        {
            value: '2',
            label: 'Signatories',
            icon: 'pi pi-user-edit',
            visible: true,
            component: SignatoriesTabComponent,
            tour: {
                stepId: 'step15'
            }
        },
        {
            value: '4',
            label: 'Linked Files',
            icon: 'pi pi-link',
            visible: currentRole === CONTRACT_USER_ROLE.OWNER || currentRole === CONTRACT_USER_ROLE.EDITOR,
            component: LinkedFilesTabComponent,
            tour: {
                stepId: 'step17'
            }
        },
        {
            value: '5',
            label: 'Milestones',
            icon: 'pi pi-flag',
            visible: true,
            component: MilestonesTabComponent,
            tour: {
                stepId: 'step18'
            }
        },
        {
            value: '6',
            label: 'Comments',
            icon: 'pi pi-comment',
            visible: !contract?.containsForm && (
                currentRole === CONTRACT_USER_ROLE.OWNER ||
                currentRole === CONTRACT_USER_ROLE.EDITOR ||
                currentRole === CONTRACT_USER_ROLE.COMMENTER
            ),
            component: CommentsTabWrapperComponent,
            tour: {
                stepId: 'step19'
            }
        },
        {
            value: '7',
            label: 'History',
            icon: 'pi pi-history',
            visible: !contract?.containsForm && (
                currentRole === CONTRACT_USER_ROLE.OWNER ||
                currentRole === CONTRACT_USER_ROLE.EDITOR
            ),
            component: HistoryTabWrapperComponent,
            tour: {
                stepId: 'step20'
            }
        }
    ];
}


